import { Alert, Anchor } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { Link } from 'react-router';
import { useAuth } from '../../auth/auth-context';

/** Aviso mientras la regla de días facturables no esté confirmada por negocio. */
export function BillingRulesWarning() {
  const { can } = useAuth();
  return (
    <Alert
      color="yellow"
      icon={<IconAlertTriangle />}
      title="Regla de días facturables pendiente de confirmar"
    >
      Los días de almacenaje se calculan con una regla provisional que todavía no se ha validado.
      Revísela y confírmela antes de emitir liquidaciones reales.{' '}
      {can('settings.manage') && (
        <Anchor component={Link} to="/configuracion">
          Ir a Configuración
        </Anchor>
      )}
    </Alert>
  );
}
